import React from 'react';
import { render } from "preact";
import {BaseComponent} from "project/general";

class AhBackButtonComponent extends BaseComponent {

    static getNamespace() {
        return 'ah-back-button';
    }

    onInit() {

        var defaultBackUrl = "/";

        if (this.options.defaultBackUrl != undefined && this.options.defaultBackUrl.length > 0)
        {
            defaultBackUrl = this.options.defaultBackUrl;
        }

        var url = document.referrer.includes(window.location.host) ? "javascript:history.back();" : defaultBackUrl;
        render(
            <a class="ah-back-button" href={url}>
                <svg>
                    <use xlinkHref="#icon-arrow-left"></use>
                </svg>
                Back
            </a>
            , this.element
        );
    }
}

export default AhBackButtonComponent;
